import React, { useState } from 'react';
import { formatSlackMessage } from '../utils/messageFormatter';
import './ReminderModal.css';

function ReminderModal({ isOpen, onClose, onSetReminder, message, users = {} }) {
  const [selectedTime, setSelectedTime] = useState('in 20 minutes');
  const [customTime, setCustomTime] = useState('');

  if (!isOpen) return null;

  const formattedText = formatSlackMessage(message?.text || '', users);
  const previewText = formattedText.substring(0, 150) + (formattedText.length > 150 ? '...' : '');

  const handleClose = () => {
    // Reset to default values when closing
    setSelectedTime('in 20 minutes');
    setCustomTime('');
    onClose();
  };

  const handleSubmit = () => {
    let timeValue = selectedTime;

    if (selectedTime === 'custom' && customTime) {
      timeValue = customTime;
    }

    onSetReminder(message, timeValue);
    // Reset and close
    setSelectedTime('in 20 minutes');
    setCustomTime('');
    onClose();
  };

  const presetTimes = [
    { value: 'in 20 minutes', label: 'In 20 minutes' },
    { value: 'in 1 hour', label: 'In 1 hour' },
    { value: 'in 3 hours', label: 'In 3 hours' },
    { value: 'tomorrow at 9am', label: 'Tomorrow at 9 AM' },
    { value: 'next week', label: 'Next week' },
    { value: 'custom', label: 'Custom...' }
  ];

  return (
    <div className="reminder-modal-overlay" onClick={handleClose}>
      <div className="reminder-modal" onClick={(e) => e.stopPropagation()}>
        <div className="reminder-modal-header">
          <h3>Remind me about this</h3>
          <button className="close-btn" onClick={handleClose}>×</button>
        </div>

        <div className="reminder-modal-body">
          <div className="reminder-message-preview">
            <div dangerouslySetInnerHTML={{ __html: previewText || 'No message text' }} />
          </div>

          <div className="reminder-time-options">
            {presetTimes.map((time) => (
              <label key={time.value} className="reminder-option">
                <input
                  type="radio"
                  name="reminder-time"
                  value={time.value}
                  checked={selectedTime === time.value}
                  onChange={(e) => setSelectedTime(e.target.value)}
                />
                <span>{time.label}</span>
              </label>
            ))}
          </div>

          {selectedTime === 'custom' && (
            <div className="custom-time-input">
              <input
                type="text"
                placeholder="e.g., 'in 2 hours', 'Friday at 3pm', 'June 1 at 10am'"
                value={customTime}
                onChange={(e) => setCustomTime(e.target.value)}
                autoFocus
              />
              <small>Slack will parse natural language time expressions</small>
            </div>
          )}
        </div>

        <div className="reminder-modal-footer">
          <button className="btn-cancel" onClick={handleClose}>
            Cancel
          </button>
          <button
            className="btn-set-reminder"
            onClick={handleSubmit}
            disabled={selectedTime === 'custom' && !customTime}
          >
            Set reminder
          </button>
        </div>
      </div>
    </div>
  );
}

export default ReminderModal;
